module.exports = {
    "crude": {
        "search": "Recherche",
        "actions": "Actions",
        "nextPage": "Page suivante",
        "lastPage": "Dernière page",
        "back": "Back",
        "empty": "empty",
        "edit": "Edit",
        "delete": "Supprimer",
        "save": "Sauvegarder",
        "success": "Sauvé avec succès",
        "invalidDataFields": "les champs de données suivants sont invalides : ",
        "create": "create",
        "data": "données",
        "view": "show",
        "cancel": "cancel",
        "noContent": "pas d'entrées",
        "resetFilter": "Reset filter to show more !",
        "createOwnTextField": "Créer son propre champ de texte",
        "textFieldName": "Label",
        "textFieldValue": "Valeur",
        "insertTextFieldLabel": "Merci d'insérer le nom",
        "deleteTextField": "delete",
        "entries": "entrées",
        "entry": "entrée",
        "tabDetail": "Détails",
        "entity": "Entité",
        "of": "of",
        "uploadNewFile": "Télécharger un nouveau fichier",
        "upload": "upload",
        "uploadErrorExtension": "Upload error - wrong extension",
        "confirm": "Ok",
        "deleteFileQuestion": "Souhaites-tu vraiment supprimer ce fichier ? L'opération ne peut pas être annulée.",
        "deleteFileQuestionTitle": "Attention !",
        "deleteEntityQuestion": "Souhaites-tu vraiment supprimer cette entité ? L'opération ne peut pas être annulée.",
        "deleteEntityeQuestionTitle": "Attention !",
        "errorLargeFileUpload": "Taille du fichier trop grande.",
        "useCroppedImage": "Utiliser l'image",
        "useOriginalImage": "Use origin",
        "available": "available",
        "searchColumn": "Colonne de recherche",
        "manageColumns": "Gérer les colonnes",
        "hideColumn": "Hide column",
        "pinToRight": "Pin à droite",
        "pinToLeft": "Pin à gauche",
        "sortAsc": "Trier ASC",
        "sortDesc": "Sort DESC",
        "hideAll": "Hide all",
        "showAll": "Montre tout",
        "preview": "Aperçu",
        "title": "Titre",
        "description": "Description",
        "tooltip": "Infobulle",
        "sort": "Trier",
        "settings": "Paramètres",
        "incomingReference": "Référence",
        "language": "Langue",
        "deleteTabQuestionTitle": "Attention !",
        "deleteTabQuestion": "Tu veux vraiment supprimer cet onglet ? Tous les paramètres de cet onglet seront réinitialisés !",
        "deleteElementQuestionTitle": "Attention !",
        "deleteElementQuestion": "Tu veux vraiment supprimer cet élément ? Tous les paramètres de cette colonne seront réinitialisés !",
        "configurationEditorDescriptionStringLayout": "Dans cette colonne, trois variantes peuvent être sélectionnées pour l'entrée du texte :",
        "configurationEditorDescriptionEnumLayout": "Deux variantes peuvent être sélectionnées pour la sélection des éléments dans cette colonne :",
        "configurationEditorDescriptionBooleanLayout": "Deux variantes peuvent être sélectionnées pour la sélection des éléments dans cette colonne :",
        "configurationEditorDescriptionForeignEntityLayout": "Deux variantes peuvent être sélectionnées pour la sélection des éléments dans cette colonne :",
        "stringLayoutsingleline": "Singleline",
        "stringLayoutmultiline": "Multiline",
        "stringLayouteditor": "RichTextEditor",
        "enumLayoutradio": "Bouton radio",
        "enumLayoutdropdown": "Dropdown",
        "booleanLayoutcheckbox": "Checkbox",
        "booleanLayoutswitch": "Switch",
        "foreignEntityLayoutpopUp": "PopUp",
        "foreignEntityLayoutautocomplete": "Dropdown",
        "foreignEntityLayoutlist": "List",
        "formatTooltipbold": "Bold",
        "formatTooltipitalic": "Italic",
        "formatTooltipunderline": "Underline",
        "formatTooltipstrike": "Strike",
        "formatTooltipclean": "Supprimer le format",
        "formatTooltipcodeBlock": "Code",
        "formatTooltipblockquote": "Quota de bloc",
        "formatTooltipcolor": "Couleur",
        "formatTooltipbackground": "Arrière-plan",
        "formatTooltipfont": "Font",
        "formatTooltipalign": "Align",
        "formatTooltipheader": "Fontsize",
        "formatTooltipsuper": "Superscript",
        "formatTooltipsub": "Subscript",
        "formatTooltipordered": "Liste de commande",
        "formatTooltipbullet": "Bullets",
        "true": "true",
        "false": "false",
        "selectEntity": "Sélectionner une entité",
        "filter": "Filtre",
        "useFilter": "Utiliser le filtre",
        "defaultFilter": "Réinitialiser le filtre",
        "expand": "Développe",
        "hide": "Hide",
        "minimumSelectionError": "Au moins {{min}} entrées doivent être sélectionnées.",
        "maximumSelectionError": "Un maximum de {{max}} entrées peuvent être sélectionnées."
    }
}
;